import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { RequestsHandler } from './requests.service';
import {Api} from '../utils';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class PricingRulesService {
    conditions = new BehaviorSubject<any>(null);

    constructor(private _http: HttpClient, private api: Api, private handler: RequestsHandler) { }
    getTypesRules() {
        return this._http
            .get(this.api.getUrl('admin/pricing-rules/parameters'), {headers: this.handler.headers()})
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(new Error(err));
            })
          .subscribe(data => {
            const ruleObjectAll = data;
            const allProducts = [];
            const ruleActions = [];
            const ruleTypes = [];
            const condLogic = [];
            const condCompare = [];
            const condProp = [];
            const condPropVal = {};
            const carrier = data.carriers;
            const carriers: any = [];
            for (const i in carrier) {
              if (Object.keys(carrier[i]['products']).length > 0) {
                carriers.push({value: carrier[i].id, label: carrier[i].name});
                const product = carrier[i]['products'];
                const products: any = [];
                for (const j in product) {
                  products.push({value: product[j].id, label: product[j].name});
                }
                allProducts[i] = products;
              }
            }
            for (const item in data['parameters']['rules']['actions']) {
              ruleActions.push({value: item, label: data['parameters']['rules']['actions'][item]});
            }

            for (const item in data['parameters']['rules']['types']) {
              ruleTypes.push({value: item, label: data['parameters']['rules']['types'][item]});
            }

            for (const item in data['parameters']['conditions']['logic_operators']) {
              condLogic.push({value: item, label: data['parameters']['conditions']['logic_operators'][item]});
            }

            for (const item in data['parameters']['conditions']['operators']) {
              condCompare.push({value: item, label: data['parameters']['conditions']['operators'][item]});
            }

            for (const item in data['parameters']['conditions']['names']) {
              condProp.push({value: item, label: item});
              const prop = data['parameters']['conditions']['names'][item];

              if (['carrier_id', 'product_id'].includes(item)) {
                condPropVal[item] = Object.keys(data['carriers']).map(key => ({
                  ...data['carriers'][key],
                  value: data['carriers'][key].id,
                  label: data['carriers'][key].name
                }));
              } else if (item === 'country') {
                condPropVal[item] = Object.keys(prop.names).map(key => ({
                  value: key,
                  label: prop.names[key]
                }));
              } else if (prop !== null && typeof prop === 'object') {
                const propVal = [];
                for (const p in prop) {
                  propVal.push({value: p, label: prop[p]});
                }
                condPropVal[item] = propVal;
              } else {
                condPropVal[item] = 'input';
              }
            }
            this.conditions.next({
              ruleActions,
              ruleTypes,
              condLogic,
              condCompare,
              condProp,
              condPropVal,
              carriers,
              allProducts
            });
          });
    }
    getPricingRules(pid: string = '') {
        let param = '';
        if (pid !== '') { param = '?product_id=' + pid; }
        return this._http
            .get(this.api.getUrl('admin/pricing-rules' + param), {headers: this.handler.headers()})
            .catch((err: any) => {
                if (err.status === 404 && err.statusText === 'Not Found') {
                    return Observable.throw(err.json().error);
                } else {
                    this.handler.handleError(err);
                    return Observable.throw(new Error(err));
                }
            });
    }
    getCustomerRules(pid: string = '') {
        let param = '';
        if (pid !== '') { param = '?user_id=' + pid; }
        return this._http
            .get(this.api.getUrl('admin/pricing-rules' + param), {headers: this.handler.headers()})
            .catch((err: any) => {
                if (err.status === 404 && err.statusText === 'Not Found') {
                    return Observable.throw(err.json().error);
                } else {
                    this.handler.handleError(err);
                    return Observable.throw(new Error(err));
                }
            });
    }
  getCampainRules() {
    return this._http
      .get(this.api.getUrl('admin/pricing-rules'), {headers: this.handler.headers()})
      .map((data: any) => data.campain || [])
      .catch((err: any) => {
        if (err.status === 404 && err.statusText === 'Not Found') {
          return Observable.throw(err.json().error);
        } else {
          this.handler.handleError(err);
          return Observable.throw(new Error(err));
        }
      });
  }
    getRuleTemplate() {
        return this._http
            .get(this.api.getUrl('admin/pricing-rule-templates'), {headers: this.handler.headers()})
            .catch((err: any) => {
                if (err.status === 404 && err.statusText === 'Not Found') {
                    return Observable.throw(err.json().error);
                } else {
                    this.handler.handleError(err);
                    return Observable.throw(new Error(err));
                }
            });
    }

    createPricingRules(data) {
        return this._http
            .post(this.api.getUrl('admin/pricing-rules'), JSON.stringify(data), {headers: this.handler.headers()})
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(new Error(err));
            });
    }

    setPricingRules(id, data) {
        return this._http
            .put(this.api.getUrl('admin/pricing-rules/' + id), JSON.stringify(data), {headers: this.handler.headers()})
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(new Error(err));
            });
    }

    removePricingRule(id) {
        return this._http
            .delete(this.api.getUrl('admin/pricing-rules/' + id), {headers: this.handler.headers()})
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(new Error(err));
            });
    }

    sortPricingRules(data) {
        return this._http
            .post(this.api.getUrl('admin/pricing-rules/sort'), JSON.stringify(data), {headers: this.handler.headers()})
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(new Error(err));
            });
    }
    saveTemplate(data) {
        return this._http
            .post(this.api.getUrl('admin/pricing-rule-templates'), JSON.stringify(data), {headers: this.handler.headers()})
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(new Error(err));
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/pricing-rules.service.ts